import { Injectable } from '@angular/core';
import { CompanyEmployeeWithSubsidyAmount } from '@app/@graphql';
import { MenuItemData } from '@app/pages/menu';
import { Observable, of } from 'rxjs';
import { DishAllergens, DishCategory, MenuTemplate, MenuTemplatesData } from '../data/restaurant-data';

@Injectable()
export class MenuTemplatesService extends MenuTemplatesData
{
    private allMenuTemplates: MenuTemplate[] = [
        {
            id: 1,
            price: 17,
            details: [{
                title: 'Potrawa 1',
                description: 'Wolnogotowana wołowina',
                languageId: 1,
                language: 'pl',
                imageUrl: 'https://zmwarmia.pl/wp-content/uploads/2018/04/Wo%C5%82owina-wolno-gotowana-ZM-Warmia_1-784x534.jpg',
                ingredients: ['Wołowina'],
                parts: ['Wołowina']
            }],
            categories: [{
                id: 1,
                languageId: 1,
                language: 'pl',
                name: 'Mięsna'
            }],
            allergens: [{
                id: 1,
                languageId: 1,
                language: 'pl',
                name: 'Orzechy'
            }]
        },
        {
            id: 2,
            price: 15,
            details: [{
                title: 'UA Potrawa 2',
                description: 'UA Zapiekanka ziemniaczana',
                languageId: 2,
                language: 'ua',
                imageUrl: 'https://pysznosci.pl/wp-content/uploads/2020/08/miniatu-zap--495x260.jpg.webp',
                ingredients: ['UA Ziemniaki'],
                parts: ['UA Ziemniaki']
            },{
                title: 'Potrawa 2',
                description: 'Zapiekanka ziemniaczana',
                languageId: 1,
                language: 'pl',
                imageUrl: 'https://pysznosci.pl/wp-content/uploads/2020/08/miniatu-zap--495x260.jpg.webp',
                ingredients: ['Ziemniaki'],
                parts: ['Ziemniaki']
            }
            ],
            categories: [{
                id: 2,
                languageId: 2,
                language: 'pl',
                name: 'Wegańska'
            }],
            allergens: [{
                id: 2,
                languageId: 1,
                language: 'pl',
                name: 'Ziemniaki'
            }]
        }
    ];

    private allCategories: DishCategory[] =  [
        {
            id: 1,
            language: 'pl',
            languageId: 1,
            name: 'Mięsna'
        },
        {
            id: 2,
            language: 'pl',
            languageId: 1,
            name: 'Wegańska'
        }
    ];

    private allAllergens: DishAllergens[] =  [
        {
            id: 1,
            language: 'pl',
            languageId: 1,
            name: 'Orzechy'
        },
        {
            id: 2,
            language: 'pl',
            languageId: 1,
            name: 'Ziemniaki'
        }
    ];

    getAllMenuTemplates(): Observable<MenuTemplate[]>{
        return of(this.allMenuTemplates);
    }    

    getAllDishCategories(): Observable<DishCategory[]> {
        return of(this.allCategories);
    }
    
    getAllAllergens(): Observable<DishAllergens[]> {
        return of(this.allAllergens);
    }
}